import { Fragment, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  A1Certificate,
  A1CertificateDetails,
  A1CertificateNew,
  Absence,
  AbsenceCalendar,
  AbsenceConfirm,
  AbsenceConfirmDetails,
  AbsenceDetails,
  AbsenceLog,
  AddressSearch,
  AddressSearchDetails,
  AnwesenheitsListe,
  Arbeitszeiterfassung,
  Auswertungsarchiv,
  Auswertungsdruck,
  AuToDo,
  // EntgeltDigital,
  // StammAnzeigen,
  ChangePassword,
  Dokumentenarchiv,
  DoorBell,
  ElectronicIllnessAttestation,
  ElectronicIllnessAttestationHistory,
  EmployeeStatistics,
  Entgeltantrag,
  EntgeltantragPersonal,
  ErgebnisRechnung,
  ErrorBoundary,
  FehlerprotokollZeit,
  FileTransfer,
  FileUpload,
  FormularAdmin,
  FormularAusfuellen,
  Formulare,
  FormularGenehmigen,
  FormularGenerator,
  FormularInfo,
  HaufToDo,
  Home,
  HRAufgabenglobal,
  HRQualifikation,
  HRRessourcen,
  HRTurnus,
  Interview,
  Lagerorte,
  MandatoryDocConfirm,
  MandatoryDocConfirmation,
  MandatoryDocDetails,
  MandatoryDocNew,
  MandatoryDocument,
  MasterDataAdress,
  MasterDataBank,
  MasterDataChange,
  MitarbeiterAbwesenheit,
  MitarbeiterPersonalmappe,
  MyDocuments,
  NewsTicker,
  NewTimeCorrection,
  NotFound,
  Payroll,
  PcStart,
  Personalmappe,
  Profile,
  Projektstamm,
  ProjektstundenAdmin,
  Projektstundenverteilung,
  Represent,
  Settings,
  StammblattMonitor,
  Stammformular,
  TestComponent,
  TimeAccount,
  TimeCorrection,
  TimeCorrection2,
  TimeCorrectionDetails,
  Timetracking,
  ToDoDynamic,
  ToDoInvite,
  ToDos,
  ToDosDetails,
  ToDosGlobal,
  ToDosNew,
  Umsatzstatistik,
  UsernameChange,
  VerifyAdmincode,
  Wertguthaben,
} from "./components";
import AbsenceArch from "./components/AbsenceArch";
import MitarbeiterAU from "./components/MitarbeiterAU/MitarbeiterAU";
import VstAnmeldung from "./components/Veranstaltungstool";
import { DEBUG_FLAG } from "./constants/debug";
import { LOCAL_STORAGE_KEY } from "./constants/localStorage";
import { useAuth } from "./context/auth-context";
import { useZulassung } from "./context/zulassungs-context";
import TransferHistory from "./pages/TransferHistory";
import { useLocalStorage, useSessionStorage } from "./utils/hooks";
import { DeviceDetails, DeviceSuche, KabelManagement, KabelSuche } from "./components/KabelManagement";
import KabelDetails from "./components/KabelManagement/KabelDetails";
import { SchwarzesBrettAnsicht } from "./components/SchwarzesBrett";


function MainRouter(props) {
  const { setTitle } = props;
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [username, setUsername] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [storagePath, setStoragePath] = useLocalStorage(LOCAL_STORAGE_KEY.path);
  const [deviceId] = useLocalStorage(DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId);
  const [redirectPath, setRedirectPath] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();
  const { zulassung } = useZulassung();
  const { mandant } = zulassung;
  useEffect(() => {
    if (user.newname) {
      navigate("/change-username");
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (storagePath !== "") {
      localStorage.setItem(LOCAL_STORAGE_KEY.path, "");
      navigate(storagePath);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (DEBUG_FLAG()) {
      localStorage.setItem(LOCAL_STORAGE_KEY.deviceIdLocal, deviceId);
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY.deviceId, deviceId);
    }
  }, [deviceId]);

  let pageHeight = "100%";

  return (
    <Suspense fallback={<Fragment />}>
      <div style={{ height: pageHeight, minHeight: pageHeight }}>
        <Routes>
          <Route
            path="/"
            element={
              <ErrorBoundary errorComponent="Home">
                <Home
                  redirectPath={redirectPath}
                  updateRedirectPath={(p) => setRedirectPath(p)}
                  username={username}
                  updateTitle={(t) => setTitle(t)}
                  accessToken={accessToken}
                />
              </ErrorBoundary>
            }
          />
          <Route
            path="/change-username"
            element={
              <ErrorBoundary errorComponent="UsernameChange">
                <UsernameChange updateTitle={(t) => setTitle(t)} deviceId={deviceId} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/verify-admincode"
            element={
              <ErrorBoundary errorComponent="VerifyAdmincode">
                <VerifyAdmincode deviceId={deviceId} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/change-password"
            element={
              <ErrorBoundary errorComponent="ChangePassword">
                <ChangePassword updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBZFP-MODUL"
            element={
              <ErrorBoundary errorComponent="FehlerprotokollZeit">
                <FehlerprotokollZeit updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBZF2"
            element={
              <ErrorBoundary errorComponent="FehlerprotokollZeit">
                <FehlerprotokollZeit updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORMUL/genehmigen/:formularkey/*"
            element={
              <ErrorBoundary errorComponent="FormularGenehmigen">
                <FormularGenehmigen updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORGEN"
            element={
              <ErrorBoundary errorComponent="FormularGenerator">
                <FormularGenerator updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORAUS"
            element={
              <ErrorBoundary errorComponent="FormularAusfuellen">
                <FormularAusfuellen updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORMUL/*"
            element={
              <ErrorBoundary errorComponent="Formulare">
                <Formulare updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          {/* <Route
            path="/WEBABR"
            element={
              <ErrorBoundary errorComponent="Formulare">
                <EntgeltDigital
                  updateTitle={(t) => setTitle(t)}
                  accessToken={accessToken}
                  client={mandant}
                />
              </ErrorBoundary>
            }
          /> */}
          <Route
            path="/FORMAD"
            element={
              <ErrorBoundary errorComponent="FormularAdmin">
                <FormularAdmin updateTitle={(t) => setTitle(t)} admin accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORMAM"
            element={
              <ErrorBoundary errorComponent="FormularAdmin">
                <FormularAdmin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURB3/*"
            element={
              <ErrorBoundary errorComponent="MitarbeiterAbwesenheit">
                <MitarbeiterAbwesenheit updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAD2"
            element={
              <ErrorBoundary errorComponent="Auswertungsdruck">
                <Auswertungsdruck updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAD3"
            element={
              <ErrorBoundary errorComponent="Auswertungsdruck">
                <Auswertungsdruck updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PPROJ2"
            element={
              <ErrorBoundary errorComponent="Projektstamm">
                <Projektstamm updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PPROJ3/*"
            element={
              <ErrorBoundary errorComponent="ProjektstundenAdmin">
                <ProjektstundenAdmin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PPROJN/*"
            element={
              <ErrorBoundary errorComponent="Projektstundenverteilung">
                <Projektstundenverteilung updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/STAMBO/:stammid"
            element={
              <ErrorBoundary errorComponent="Stammformular">
                <Stammformular updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LPB1AP/*"
            element={
              <ErrorBoundary errorComponent="StammblattMonitor">
                <StammblattMonitor updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/SPLANT/:antragid"
            element={
              <ErrorBoundary errorComponent="Arbeitszeiterfassung">
                <Arbeitszeiterfassung updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/SPLANT"
            element={
              <ErrorBoundary errorComponent="Arbeitszeiterfassung">
                <Arbeitszeiterfassung updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORANT/personal/:antragid"
            element={
              <ErrorBoundary errorComponent="EntgeltantragPersonal">
                <EntgeltantragPersonal updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORANT/:antragid"
            element={
              <ErrorBoundary errorComponent="Entgeltantrag">
                <Entgeltantrag updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FORANT"
            element={
              <ErrorBoundary errorComponent="Entgeltantrag">
                <Entgeltantrag updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMBZE0"
            element={
              <ErrorBoundary errorComponent="Timetracking">
                <Timetracking updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMVER0"
            element={
              <ErrorBoundary errorComponent="Represent">
                <Represent updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA1/antragdetailsuser/:antragid"
            element={
              <ErrorBoundary errorComponent="AbsenceDetails">
                <AbsenceDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/interview/:interview"
            element={
              <ErrorBoundary errorComponent="Interview">
                <Interview updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA1/*"
            element={
              <ErrorBoundary errorComponent="Absence">
                <Absence updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA3/protokoll"
            element={
              <ErrorBoundary errorComponent="AbsenceLog">
                <AbsenceLog updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA3/archiv"
            element={
              <ErrorBoundary errorComponent="AbsenceArchiv">
                <AbsenceArch updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA3/korrekturdetails/:antragid"
            element={
              <ErrorBoundary errorComponent="TimeCorrectionDetails">
                <TimeCorrectionDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA3/antragsdetails/:antragid"
            element={
              <ErrorBoundary errorComponent="AbsenceConfirmDetails">
                <AbsenceConfirmDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMURA3"
            element={
              <ErrorBoundary errorComponent="AbsenceConfirm">
                <AbsenceConfirm updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/SENDAU"
            element={
              <ErrorBoundary errorComponent="ElectronicIllnessAttestation">
                <ElectronicIllnessAttestation updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/SNDAUM/*"
            element={
              <ErrorBoundary errorComponent="MitarbeiterAU">
                <MitarbeiterAU updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/SENDAU/HISTORIE"
            element={
              <ErrorBoundary errorComponent="ElectronicIllnessAttestationHistory">
                <ElectronicIllnessAttestationHistory updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PERSMA"
            element={
              <ErrorBoundary errorComponent="Personalmappe">
                <Personalmappe client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PERSMM/*"
            element={
              <ErrorBoundary errorComponent="MitarbeiterPersonalmappe">
                <MitarbeiterPersonalmappe updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/NEWS/*"
            element={
              <ErrorBoundary errorComponent="NewsTicker">
                <NewsTicker updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/TUERAP"
            element={
              <ErrorBoundary errorComponent="DoorBell">
                <DoorBell client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PCRSHO"
            element={
              <ErrorBoundary errorComponent="PCStart">
                <PcStart user={user} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/BRETTL"
            element={
              <ErrorBoundary errorComponent="PCStart">
                <SchwarzesBrettAnsicht updateTitle={(t) => setTitle(t)} user={user}></SchwarzesBrettAnsicht>
              </ErrorBoundary>
            }
          />
          <Route
            path="/HRTURN"
            element={
              <ErrorBoundary errorComponent="HRTurnus">
                <HRTurnus updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/HRFIRE"
            element={
              <ErrorBoundary errorComponent="HRRessourcen">
                <HRRessourcen updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/HRQUAL"
            element={
              <ErrorBoundary errorComponent="HRQualifikation">
                <HRQualifikation updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/HRAUFG"
            element={
              <ErrorBoundary errorComponent="HRAufgabenglobal">
                <HRAufgabenglobal updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/HRLORT"
            element={
              <ErrorBoundary errorComponent="Lagerorte">
                <Lagerorte updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGG"
            element={
              <ErrorBoundary errorComponent="ToDosGlobal">
                <ToDosGlobal updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/*"
            element={
              <ErrorBoundary errorComponent="ToDos">
                <ToDos />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/add"
            element={
              <ErrorBoundary errorComponent="ToDosNew">
                <ToDosNew accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/aufgabe/:todokey"
            element={
              <ErrorBoundary errorComponent="ToDosDetails">
                <ToDosDetails accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/dynamisch/:todokey"
            element={
              <ErrorBoundary errorComponent="ToDoDynamic">
                <ToDoDynamic accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/haufDynamisch/:todokey"
            element={
              <ErrorBoundary errorComponent="ToDoDynamic">
                <HaufToDo accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/AuToDo/:todokey"
            element={
              <ErrorBoundary errorComponent="ToDoDynamic">
                <AuToDo accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/formularInfo/:todokey"
            element={
              <ErrorBoundary errorComponent="ToDoDynamic">
                <FormularInfo accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBAGU/inviteKey/:inviteKey"
            element={
              <ErrorBoundary errorComponent="ToDoInvite">
                <ToDoInvite accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />

          <Route
            path="/WEBAGU"
            element={
              <ErrorBoundary errorComponent="ToDos">
                <ToDos updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBDMS"
            element={
              <ErrorBoundary errorComponent="Dokumentenarchiv">
                <Dokumentenarchiv updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/UMSTAT"
            element={
              <ErrorBoundary errorComponent="Umsatzstatistik">
                <Umsatzstatistik updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/KMPAPI"
            element={
              <ErrorBoundary errorComponent="KabelManagement">
                <KabelManagement user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/KMPAPI/kabel"
            element={
              <ErrorBoundary errorComponent="KabelSuche">
                <KabelSuche user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/KMPAPI/device"
            element={
              <ErrorBoundary errorComponent="DeviceSuche">
                <DeviceSuche user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/KMPAPI/device/:id"
            element={
              <ErrorBoundary errorComponent="DeviceDetails">
                <DeviceDetails user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/KMPAPI/kabel/:id"
            element={
              <ErrorBoundary errorComponent="KabelDetails">
                <KabelDetails user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/HVATAN"
            element={
              <ErrorBoundary errorComponent="VstAnmeldung">
                <VstAnmeldung user={user} updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP-INIT_AN/edit/:antragid"
            element={
              <ErrorBoundary errorComponent="A1CertificateDetails">
                <A1CertificateDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP-INIT_AN/new/:antragid"
            element={
              <ErrorBoundary errorComponent="A1CertificateNew">
                <A1CertificateNew updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP-INIT_AN/new"
            element={
              <ErrorBoundary errorComponent="A1CertificateNew">
                <A1CertificateNew updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP-INIT_AN"
            element={
              <ErrorBoundary errorComponent="A1Certificate">
                <A1Certificate updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP/edit/:antragid"
            element={
              <ErrorBoundary errorComponent="A1CertificateDetails">
                <A1CertificateDetails admin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP/new/:antragid"
            element={
              <ErrorBoundary errorComponent="A1CertificateNew">
                <A1CertificateNew admin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP/new"
            element={
              <ErrorBoundary errorComponent="A1CertificateNew">
                <A1CertificateNew admin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LA1MAP"
            element={
              <ErrorBoundary errorComponent="A1Certificate">
                <A1Certificate admin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/GESEND"
            element={
              <ErrorBoundary errorComponent="TransferHistory">
                <TransferHistory updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/ADRWEB/:key"
            element={
              <ErrorBoundary errorComponent="AddressSearchDetails">
                <AddressSearchDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/ADRWEB"
            element={
              <ErrorBoundary errorComponent="AddressSearch">
                <AddressSearch updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKOA0/new/:defaultdate"
            element={
              <ErrorBoundary errorComponent="NewTimeCorrection">
                <NewTimeCorrection updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKOA0/edit/:antragid"
            element={
              <ErrorBoundary errorComponent="TimeCorrectionDetails">
                <TimeCorrectionDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKOA0/new"
            element={
              <ErrorBoundary errorComponent="NewTimeCorrection">
                <NewTimeCorrection updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKOA0/:date"
            element={
              <ErrorBoundary errorComponent="TimeCorrection2">
                <TimeCorrection2 updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKOA0"
            element={
              <ErrorBoundary errorComponent="TimeCorrection">
                <TimeCorrection updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/INOBRW"
            element={
              <ErrorBoundary errorComponent="TestComponent">
                <TestComponent updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PZKDR0"
            element={
              <ErrorBoundary errorComponent="TimeAccount">
                <TimeAccount updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMAST0"
            element={
              <ErrorBoundary errorComponent="EmployeeStatistics">
                <EmployeeStatistics updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMAST1"
            element={
              <ErrorBoundary errorComponent="EmployeeStatistics">
                <EmployeeStatistics admin updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/CWARCH"
            element={
              <ErrorBoundary errorComponent="FileUpload">
                <FileUpload updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LTERW2"
            element={
              <ErrorBoundary errorComponent="FileTransfer">
                <FileTransfer updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LWEB01"
            element={
              <ErrorBoundary errorComponent="Payroll">
                <Payroll updateTitle={(t) => setTitle(t)} accessToken={accessToken} deviceId={deviceId} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/DMSBAP"
            element={
              <ErrorBoundary errorComponent="MyDocuments">
                <MyDocuments updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBWGD"
            element={
              <ErrorBoundary errorComponent="Wertguthaben">
                <Wertguthaben updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMABWU"
            element={
              <ErrorBoundary errorComponent="AbsenceCalendar">
                <AbsenceCalendar updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMABW2"
            element={
              <ErrorBoundary errorComponent="AbsenceCalendar">
                <AbsenceCalendar updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} admin />
              </ErrorBoundary>
            }
          />
          <Route
            path="/PMABW3"
            element={
              <ErrorBoundary errorComponent="AbsenceCalendar">
                <AbsenceCalendar updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} annonym />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBPDS/:pflichtdok"
            element={
              <ErrorBoundary errorComponent="MandatoryDocConfirmation">
                <MandatoryDocConfirmation updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBPDS"
            element={
              <ErrorBoundary errorComponent="Home">
                <MandatoryDocNew updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBPDB/pflichtdoc/details/:pflichtdok"
            element={
              <ErrorBoundary errorComponent="MandatoryDocDetails">
                <MandatoryDocDetails updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBPDB/pflichtdoc/confirm/:pflichtdok"
            element={
              <ErrorBoundary errorComponent="MandatoryDocConfirm">
                <MandatoryDocConfirm updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/WEBPDB"
            element={
              <ErrorBoundary errorComponent="MandatoryDocument">
                <MandatoryDocument updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/ZANLIM"
            element={
              <ErrorBoundary errorComponent="AnwesenheitsListe">
                <AnwesenheitsListe updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/ZANLIA"
            element={
              <ErrorBoundary errorComponent="AnwesenheitsListe">
                <AnwesenheitsListe updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/ZANLII"
            element={
              <ErrorBoundary errorComponent="AnwesenheitsListe">
                <AnwesenheitsListe updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LWEB02/bank"
            element={
              <ErrorBoundary errorComponent="MasterDataBank">
                <MasterDataBank updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LWEB02/adress"
            element={
              <ErrorBoundary errorComponent="MasterDataAdress">
                <MasterDataAdress updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/LWEB02"
            element={
              <ErrorBoundary errorComponent="MasterDataChange">
                <MasterDataChange updateTitle={(t) => setTitle(t)} accessToken={accessToken} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/AWARCH"
            element={
              <ErrorBoundary errorComponent="Auswertungsarchiv">
                <Auswertungsarchiv updateTitle={(t) => setTitle(t)} client={mandant} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/FWEBEG"
            element={
              <ErrorBoundary errorComponent="ErgebnisRechnung">
                <ErgebnisRechnung deviceId={deviceId} accessToken={accessToken} username={username} client={mandant} updateTitle={(t) => setTitle(t)} />
              </ErrorBoundary>
            }
          />

          <Route
            path="/settings"
            element={
              <ErrorBoundary errorComponent="Settings">
                <Settings deviceId={deviceId} accessToken={accessToken} updateTitle={(t) => setTitle(t)} />
              </ErrorBoundary>
            }
          />
          <Route
            path="/profile"
            element={
              <ErrorBoundary errorComponent="Profile">
                <Profile deviceId={deviceId} accessToken={accessToken} username={username} client={mandant} updateTitle={(t) => setTitle(t)} />
              </ErrorBoundary>
            }
          />
          <Route path="/login" element={<Navigate to="/" replace={true} />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </div>
    </Suspense>
  );
}

export default MainRouter;
